//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The payment state to show in clients.
*
* 
*  * PAYMENT_REQUIRED value: PAYMENT_REQUIRED - User payment is required. 
*  * PAYMENT_NOT_REQUIRED value: PAYMENT_NOT_REQUIRED - User payment is not required. 
*  * PAYMENT_PROCESSING value: PAYMENT_PROCESSING - Payment is being processed by the payment provider. 
*  * PAYMENT_WAITING value: PAYMENT_WAITING - Waiting for payment (e.g. pre-payment / Vorkasse) 
*  * PAYMENT_SUCCESSFUL value: PAYMENT_SUCCESSFUL - Payment successful. 
*/
@Serializable
enum class PaymentState(val value: kotlin.String) {

    @SerialName(value = "PAYMENT_REQUIRED")
    PAYMENT_REQUIRED("PAYMENT_REQUIRED"),

    @SerialName(value = "PAYMENT_NOT_REQUIRED")
    PAYMENT_NOT_REQUIRED("PAYMENT_NOT_REQUIRED"),

    @SerialName(value = "PAYMENT_PROCESSING")
    PAYMENT_PROCESSING("PAYMENT_PROCESSING"),

    @SerialName(value = "PAYMENT_WAITING")
    PAYMENT_WAITING("PAYMENT_WAITING"),

    @SerialName(value = "PAYMENT_SUCCESSFUL")
    PAYMENT_SUCCESSFUL("PAYMENT_SUCCESSFUL");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is PaymentState) "$data" else null

    /**
    * Returns a valid [PaymentState] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): PaymentState? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

